const doc = [({"da":({"js":({"admin":({"routes":({"webshop":({"photo_products":({"products":"Produkter"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;